// extracted by mini-css-extract-plugin
module.exports = {"aplixLoadingIndicator":"aplixLoadingIndicator--e4af9"};